import { GetterTree } from 'vuex'
import { RootState } from 'store'
import { ProfileState } from './types'
import { AUTH_TOKEN_KEY } from 'core/constants'

export const getters: GetterTree<ProfileState, RootState> = {
  
}
